import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import { SimpleRenderer } from "@arcgis/core/renderers";


const rasterpntRenderer = new SimpleRenderer({
    symbol: {
        type: "simple-fill",
        color: null,
        outline: null,
    },
})

// use the raster points with 25 meters buffer for statistic
export const rasterLayer = new FeatureLayer({
    // use the 25-meter buffer around raster point layer in LEAE
    url:"https://ispacevm09.researchstudio.at/arcgis/rest/services/Hosted/HaltestellenAnalyseFeatureDataset/FeatureServer/3",
    popupEnabled: false,
    outFields:["*"],
    renderer: rasterpntRenderer,
    listMode: "hide",
})

export const statisticRasterLayer = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/HaltestellenAnalyseMapImageLayerDataset_Statistik/MapServer",
    popupEnabled: false,
    visible: false,
    title: "Statistik",
    sublayers: [
        {
            id: 1,
            visible: false,
            opacity: 0.7,
            title: "Tagesbevölkrung",
            legendEnabled: true
        },
        {
            id: 0,
            visible: true,
            opacity: 0.7,
            title: "Einwohner",
            legendEnabled: true
        }]
});


export const haltestellenLayer = new FeatureLayer({
    url:"https://ispacevm09.researchstudio.at/arcgis/rest/services/Hosted/HaltestellenAnalyseFeatureDataset/FeatureServer/2",
    popupEnabled: true,
    outFields:["*"],
    orderBy: [{
        field: "umst_agg_m",
        order: "ascending"
    }],
    title: "Haltestellen",
})

export const infrastrukturQualitaetLayer = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/HaltestellenAnalyseMapImageLayerDataset/MapServer",
    popupEnabled: false,
    visible: false,
    listMode: "hide-children",// only one layer here, so hide children layer
    title: "Infrastruktur Qualität im Wohnfeld Land Salzburg (Projekt GEL-SEP)",
    sublayers: [
        {
            id: 0,
            visible: true,
            opacity: 0.7,
            title: "Infrastruktur Qualität",
            legendEnabled: true
        }
        ]
})

export const einwohnerImUmkreis1000 = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/Einwohner_im_umkreis_von_1000m_candidate_locations_entlang_gip_3857/MapServer",
    popupEnable: false,
    title: "Einwohner im Umkreis 1000m",
    listMode: "hide-children",
    visible: false,
});

export const mobilfunkStundengruppenLayer5Uhr = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/HaltestellenAnalyseMapImageLayerDataset/MapServer",
    popupEnabled: false,
    title: "Auspendler 5 - 6 Uhr",
    visible: true,
    opacity:0.7,
    listMode: "hide-children",
    sublayers: [
        {
            id: 3,
            visible: true,
            legendEnabled: true,
        },
        {
            id: 2,
            visible: true,
            legendEnabled: false
        }
        ]
})
export const mobilfunkStundengruppenLayer6Uhr = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/HaltestellenAnalyseMapImageLayerDataset/MapServer",
    popupEnabled: false,
    title: "Auspendler 6 - 7 Uhr",
    visible: false,
    opacity:0.7,
    listMode: "hide-children",
    sublayers: [
        {
            id: 6,
            visible: true,
            legendEnabled: true,
        },
        {
            id: 5,
            visible: true,
            legendEnabled: false
        }
    ]
})
export const mobilfunkStundengruppenLayer7Uhr = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/HaltestellenAnalyseMapImageLayerDataset/MapServer",
    popupEnabled: false,
    title: "Auspendler 7 - 8 Uhr",
    visible: false,
    opacity:0.7,
    listMode: "hide-children",
    sublayers: [
        {
            id: 9,
            visible: true,
            legendEnabled: true,
        },
        {
            id: 8,
            visible: true,
            legendEnabled: false
        }
    ]
})
export const mobilfunkStundengruppenLayer8Uhr = new MapImageLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/HaltestellenAnalyseMapImageLayerDataset/MapServer",
    popupEnabled: false,
    title: "Auspendler 8 - 9 Uhr",
    visible: false,
    opacity:0.7,
    listMode: "hide-children",
    sublayers: [
        {
            id: 12,
            visible: true,
            legendEnabled: true,
        },
        {
            id: 11,
            visible: true,
            legendEnabled: false
        }
    ]
})

export const poiSchoolLayer = new FeatureLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/Hosted/HaltestellenAnalyseFeatureDataset/FeatureServer/1",
    title:"Schulstandorte",
    outFields: ["*"],
    visible: true,
    // renderer: {
    //     type: "simple",
    //     symbol: {
    //         type: "picture-marker",
    //         url: "school-icon.png",
    //         width: "22px",
    //         height: "22px",
    //     },
    // },
})

export const poiLebensmittelLayer = new FeatureLayer({
    url: "https://ispacevm09.researchstudio.at/arcgis/rest/services/Hosted/HaltestellenAnalyseFeatureDataset/FeatureServer/0",
    title:"Lebensmittel Nahversorgung",
    outFields: ["*"],
    visible: true,
    // renderer: {
    //     type: "simple",
    //     symbol: {
    //         type: "picture-marker",
    //         url: "lebensmittel-icon.png",
    //         width: "22px",
    //         height: "22px",
    //     },
    // },
})
